// Branded dark fallback shown when a third-party thumbnail fails to load.
export const FALLBACK_POSTER =
  "data:image/svg+xml;charset=utf-8," +
  encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" width="640" height="360" viewBox="0 0 640 360">
  <rect width="640" height="360" fill="#0A0A0A"/>
  <rect width="640" height="360" fill="url(#g)"/>
  <defs>
    <radialGradient id="g" cx="50%" cy="45%" r="60%">
      <stop offset="0%" stop-color="#1a1206"/>
      <stop offset="100%" stop-color="#080808"/>
    </radialGradient>
  </defs>
  <g fill="none" stroke="#FFB000" stroke-width="6" opacity="0.85" transform="translate(320 150)">
    <circle r="46"/>
    <circle r="9" fill="#FFB000" stroke="none"/>
    <circle cx="0" cy="-30" r="8" fill="#FFB000" stroke="none"/>
    <circle cx="26" cy="15" r="8" fill="#FFB000" stroke="none"/>
    <circle cx="-26" cy="15" r="8" fill="#FFB000" stroke="none"/>
  </g>
  <text x="320" y="250" text-anchor="middle" font-family="Georgia, serif" font-size="30" fill="#EDEDED">Reel<tspan fill="#FFB000">Vault</tspan></text>
  <text x="320" y="278" text-anchor="middle" font-family="monospace" font-size="12" letter-spacing="3" fill="#666">PREVIEW UNAVAILABLE</text>
</svg>`);

export const onImgError = (e) => {
  if (e.currentTarget.src !== FALLBACK_POSTER) e.currentTarget.src = FALLBACK_POSTER;
};
